/**
 * Master Bot - Wallet Page
 * Vendor wallet balance and transactions
 */

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import Navbar from '../../components/Navbar';
import Card from '../../components/Card';
import Button from '../../components/Button';
import DataTable from '../../components/DataTable';
import { useTelegram } from '../../hooks/useTelegram';

const BalanceCard = styled(Card)`
  text-align: center;
  background: linear-gradient(135deg, var(--accent-green) 0%, #45a049 100%);
  color: white;
  margin-bottom: var(--spacing-lg);
`;

const BalanceLabel = styled.div`
  font-size: var(--font-md);
  opacity: 0.9;
  margin-bottom: var(--spacing-sm);
`;

const BalanceAmount = styled.div`
  font-size: var(--font-huge);
  font-weight: var(--font-bold);
  margin-bottom: var(--spacing-lg);
`;

const ActionButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-md);
`;

const ActionButton = styled(Button)`
  background: white;
  color: var(--accent-green);

  &:hover {
    opacity: 0.9;
  }
`;

const SectionTitle = styled.h3`
  font-size: var(--font-lg);
  font-weight: var(--font-semibold);
  color: var(--text-primary);
  margin: var(--spacing-lg) 0 var(--spacing-md);
`;

const Amount = styled.span<{ positive: boolean }>`
  font-weight: var(--font-semibold);
  color: ${({ positive }) => (positive ? 'var(--accent-green)' : 'var(--accent-red)')};
`;

const MasterWallet: React.FC = () => {
  const navigate = useNavigate();
  const { showBackButton } = useTelegram();
  const [balance] = useState(125.50);
  const [transactions] = useState([
    {
      id: 1,
      type: 'credit',
      description: 'Referral Reward',
      amount: 5.0,
      date: 'Oct 5, 2025',
    },
    {
      id: 2,
      type: 'debit',
      description: 'Bot Subscription - @mystorebot',
      amount: -5.0,
      date: 'Oct 1, 2025',
    },
    {
      id: 3,
      type: 'credit',
      description: 'Wallet Top-up',
      amount: 100.0,
      date: 'Sep 28, 2025',
    },
    {
      id: 4,
      type: 'credit',
      description: 'Referral Reward',
      amount: 5.0,
      date: 'Sep 25, 2025',
    },
  ]);

  useEffect(() => {
    showBackButton(() => navigate('/master/dashboard'));
  }, [showBackButton, navigate]);

  const columns = [
    {
      key: 'description',
      label: 'Description',
      render: (value: string, row: any) => (
        <div>
          <div style={{ fontWeight: 'var(--font-medium)' }}>{value}</div>
          <div style={{ fontSize: 'var(--font-sm)', color: 'var(--text-secondary)', marginTop: '4px' }}>
            {row.date}
          </div>
        </div>
      ),
    },
    {
      key: 'amount',
      label: 'Amount',
      render: (value: number) => (
        <Amount positive={value > 0}>
          {value > 0 ? '+' : ''}${Math.abs(value).toFixed(2)}
        </Amount>
      ),
    },
  ];

  return (
    <Layout header={<Navbar title="Wallet" subtitle="Vendor Balance" showBack />}>
      <BalanceCard>
        <BalanceLabel>Available Balance</BalanceLabel>
        <BalanceAmount>${balance.toFixed(2)}</BalanceAmount>
        {/* Hidden for now - will be implemented later
        <ActionButtons>
          <ActionButton>💳 Add Funds</ActionButton>
          <ActionButton>💸 Withdraw</ActionButton>
        </ActionButtons>
        */}
      </BalanceCard>

      <SectionTitle>Recent Transactions</SectionTitle>
      <DataTable columns={columns} data={transactions} emptyMessage="No transactions yet" />
    </Layout>
  );
};

export default MasterWallet;
